module.exports = __webpack_public_path__ + "img/coffee_desktop.df523459.jpg";